import React, { useEffect, useState } from 'react';
import {
  formatDate,
  formatNumber,
  getOrderStatus,
  getUserName,
  handleApiError
} from 'utils/functions';
import { apiService } from 'utils/api';
import { ReactComponent as EmptyIcon } from 'assets/icons/empty-search-result.svg';
import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';

import useDashboardContext from 'contexts/dashboard.context';
import { OrderType } from 'models/order.model';
import OrderStatus from 'components/base/order-status';

const TABLE_HEADERS = [
  'Order Number',
  'Customer Name',
  'Rider',
  'Recall Reason',
  'Cost',
  'Recall Date',
  'Completion Date',
  'Status'
];

const baseUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;

const RecalledOrderTable = ({ dateRange }: { dateRange: { startDate: Date; endDate: Date } }) => {
  const { activeCokitchen } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const [localOrders, setLocalOrders] = useState<OrderType[]>([]);
  const [total, setTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    setPageNumber(1);
  }, [dateRange]);
  const fetchListItems = async () => {
    setLoading(true);
    try {
      const params = {
        cokitchen_id: activeCokitchen.id,
        start_date: dateRange.startDate,
        end_date: dateRange.endDate
      };
      const res = await apiService.get('orders/all/recalled', { params, baseUrl });
      const { results, total } = res.data.data;
      setTotal(total);
      setLocalOrders(results);
    } catch (e) {
      handleApiError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    updatePageNumber({ selected: 0 });
  }, []);

  useEffect(() => {
    fetchListItems();
  }, [pageNumber, dateRange]);

  const updatePageNumber = async (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    setPageNumber(pageNo);
  };

  return (
    <div>
      {localOrders.length === 0 && !loading ? (
        <div className='flex justify-center items-center'>
          <div>
            <EmptyIcon />
            <p className='py-3'>No recalled orders</p>
          </div>
        </div>
      ) : (
        <Table
          hideOnMobile
          headers={TABLE_HEADERS}
          loading={loading}
          pageCount={Math.ceil(total / 10)}
          onPageChange={updatePageNumber}>
          {localOrders?.map((item, index) => (
            <TableRow key={index}>
              <TableData className='text-left text-[#858585]'>{item.order_code}</TableData>
              <TableData className='text-left py-6'>{getUserName(item.user)}</TableData>
              <TableData>{getUserName(item.rider)}</TableData>
              <TableData className='text-left py-6'>{item?.order_recalled_note ?? '-'}</TableData>
              <TableData className='text-left py-6'>
                {formatNumber(item?.calculated_order?.total_amount)}
              </TableData>
              <TableData className='text-left py-6'>
                {formatDate(item?.order_recalled_time ?? '') ?? '-'}
              </TableData>
              <TableData>{item?.completed_time ? formatDate(item?.completed_time) : '-'}</TableData>
              <TableData>{<OrderStatus type={getOrderStatus(item)} />}</TableData>
            </TableRow>
          ))}
        </Table>
      )}
    </div>
  );
};

export default RecalledOrderTable;
